import Env from '../../base/env'

export default class Grid
{
    constructor(component)
    {
        this.view = component.view
        this.$grid = component.$grid
        this.$items = component.$gridItems
        this.$cursor = component.view.querySelector('.jsDiscover')
        // Vars Cursor
        this.currentPosition = { x : 0 , y : 0 }
        this.newPosition = { x : 0 , y : 0 }
        this.inertia = 4
        // Flags
        this.CAN_MOUSEMOVE = false
        // Fns
        this.fnMousemove = this.getMousemove.bind(this)
        this.events()
    }

    destroy()
    {
        Env.$window.removeEventListener("mousemove", this.fnMousemove);
    }

    enableMousemove()
    {
        this.CAN_MOUSEMOVE = true
    }

    events()
    {
        Env.$window.addEventListener('mousemove',this.fnMousemove)
        this.eventsItems()
    }

    eventsItems()
    {
        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            $item.addEventListener('mouseenter',()=>{
                this.$cursor.classList.add('is--active')
                if(Env.$body.classList.contains('cursor-disabled') === false) {
                    Env.$body.classList.add('cursor-disabled')
                }
            })
            $item.addEventListener('mouseleave',()=>{
                this.$cursor.classList.remove('is--active')
                if(Env.$body.classList.contains('cursor-disabled') === true) {
                    Env.$body.classList.remove('cursor-disabled')
                }
            })
        }
    }

    getMousemove(e)
    {
        this.currentPosition.x = e.clientX
        this.currentPosition.y = e.clientY
    }

    refresh(items)
    {
        this.$items = items
        this.eventsItems()
    }

    onWatch()
    {
        if(this.CAN_MOUSEMOVE === true) {
            this.newPosition.x += (this.currentPosition.x - this.newPosition.x) / this.inertia
            this.newPosition.y += (this.currentPosition.y - this.newPosition.y) / this.inertia
            TweenLite.set(this.$cursor , { x : this.newPosition.x , y : this.newPosition.y })
        }
    }
}